interface DynamicProgressBarProps {
  percentage: number;
  startNumber: string | null;
  currentNumber: string | null;
  endNumber: number;
}

const DynamicProgressBar = ({
  percentage = 70,
  startNumber = '45',
  currentNumber = '-22',
  endNumber = 23,
}: DynamicProgressBarProps) => {
  const safePercentage = Math.min(Math.max(percentage, 0), 100);

  const startX = 50;
  const endX = 950;
  const width = endX - startX;

  const currentX = startX + width * (safePercentage / 100);

  return (
    <div className="col-xxl-12">
      <div className="card card-animate shadow-lg">
        <div className="card-body">
          <svg viewBox="0 0 1000 150" className="w-100" xmlns="http://www.w3.org/2000/svg">
            <line x1={startX} y1="75" x2={endX} y2="75" stroke="#d8b4e2" strokeWidth="2" />

            <line x1={startX} y1="75" x2={currentX} y2="75" stroke="#9b59b6" strokeWidth="8" strokeLinecap="round" />

            <circle cx={startX} cy="75" r="6" fill="#9b59b6" />
            <circle cx={endX} cy="75" r="6" fill="#9b59b6" />

            <line x1={currentX} y1="65" x2={currentX} y2="85" stroke="#9b59b6" strokeWidth="2" />

            <text x={startX} y="35" textAnchor="middle" fill="#9b59b6">
              Start weight
            </text>
            <text x={endX} y="35" textAnchor="middle" fill="#9b59b6">
              Current weight
            </text>

            <text x={currentX} y="60" textAnchor="middle" fontSize="20">
              🐭
            </text>

            <text x={currentX} y="105" textAnchor="middle" fill="red" fontWeight="bold">
              {currentNumber}g
            </text>

            <text x={startX} y="135" textAnchor="middle" fill="#9b59b6">
              {startNumber}g
            </text>
            <text x={endX} y="135" textAnchor="middle" fill="#9b59b6">
              {Math.round(endNumber)}g
            </text>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default DynamicProgressBar;
